import { render, staticRenderFns } from "./LoadIndicator.vue?vue&type=template&id=2f884922&"
import script from "./LoadIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports